import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AepsService } from '../aeps/aeps.service';
import { AuthService } from '../auth/auth.service';
import { KycService } from '../services/kyc.service';
import { Observable } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { KYCSuccessDialogComponentComponent } from '../kycsuccess-dialog-component/kycsuccess-dialog-component.component';
import { AepsdeviceConfigModelComponent } from '../aeps/aepsdevice-config-model/aepsdevice-config-model.component';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.scss']
})
export class TwoFactorAuthenticationComponent implements OnInit {
  devices:any;
  kycForm: FormGroup;
  submitted: boolean;
  deviceInfo: any;
  lat;
  lng;
  zoom;
  service: any;
  obj: any;
  captureDeviceInfoObj: any;
  deviceCaptureInfo: any;
  selectedServiceType: any;
  deviceStringData: string;
  ipAddress: any;
  finoRequest: { captureResponse: { ci: any; dc: any; dpID: any; errCode: any; errInfo: any; fCount: any; fType: any; hmac: any; iCount: string; mc: any; mi: any; nmPoints: any; pCount: string; pType: string; pidDatatype: any; piddata: any; qScore: any; rdsID: any; rdsVer: any; sessionKey: any; }; cardnumberORUID: { adhaarNumber: any; indicatorforUID: number; }; latitude: string; longitude: string; mobileNumber: any; requestRemarks: string; };
 
  constructor(private formBuilder: FormBuilder,
    private kycservice: KycService,
    private toastr: ToastrService,
    private Aeps: AepsService,
    config: NgbModalConfig,
    private auth: AuthService,
    private activatedRoute:ActivatedRoute,
    private router: Router,    
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private ngxXml2jsonService: NgxXml2jsonService,
    private loader:NgxUiLoaderService
    
  ) {
    this.kycForm = this.formBuilder.group({
      aadharNum: ['', Validators.required],
      mobileNum: ['', Validators.required],
      device: ['', Validators.required],
      // comment: ['ok', Validators.required],
      // otp: [''],
    });

    this.activatedRoute.params.subscribe(params => {
      if (params) {
        console.log("loook here =",params);
       this.service=params.service;
       this.selectedServiceType=params.selectedServiceType; 
      }

    });
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;

      });
    }

   

  }
  
  handleError = (error: HttpErrorResponse): any => {
    console.log('error', error);
  }
  get d() { return this.kycForm.controls; }

  ngOnInit(): void {
    this.getDevices();
    this.auth.getIp().subscribe((res:any)=>{
      this.ipAddress=res.ip;
     })
  }
  getDevices(){
   
    this.auth.getDevicesApi().subscribe((res: any) => {
      if (res.status_code == 1) {
          this.devices=res.object;
          // if

      } else {
        // this.toastr.error(res.error.message);

      }
    }, errData => {
      this.spinner.hide()
    })
  

}
  XMLToString(oXML)
  {
  return (new XMLSerializer()).serializeToString(oXML);
  }
  startScan(){ 
    this.loader.start();   
    this.submitted = true;
    // stop here if form is invalid
    if (this.kycForm.invalid) {
      return;
    }
    else {
    this.deviceInfoAvdm();}
  }
  deviceInfoAvdm() {       
    // this.loader.stop();   
  
    this.spinner.show();   
    const xhr = new XMLHttpRequest();
    let deviceValue = this.kycForm.value.device;
    console.log(deviceValue);                
    let  url ='https://127.0.0.1:11100/rd/info';
    if (deviceValue==1) {
      url="https://127.0.0.1:11100/getDeviceInfo";
    }      
    if (deviceValue==6) {
      url="https://127.0.0.1:8005/rd/info";
    }      
    xhr.open('DEVICEINFO', url,true);
    // set `Content-Type` header
    xhr.setRequestHeader('Content-Type', 'text/xml');
    xhr.send();
    this.spinner.hide();

    // listen for `load` event
    xhr.onload = () => {
      const parser = new DOMParser();
      const xml = parser.parseFromString(xhr.responseText, 'text/xml');
      this.obj = this.ngxXml2jsonService.xmlToJson(xml);
      this.deviceCapture(this.kycForm.value.device);
      // this.currentdeviceInfoSubject.next(this.obj);
    };
    xhr.onerror = function (e) {
      console.log('eoor', e);
      
      if (e.type == 'error') {

        alert('please download the Driver');
        let deviceUrl = ''
        switch (deviceValue) {
          case 6:
            deviceUrl = 'https://download.mantratecapp.com/Forms/DownLoadFiles';
            break;
        
          case 3:
            deviceUrl = 'https://download.mantratecapp.com/Forms/DownLoadFiles';
            break;
        
          case 8:
            deviceUrl = 'https://drive.google.com/file/d/1lKJKedZRu2yJ3lDgxDdW_8nA7V9VQjz1/view';
            break;
        
          case 1:
            deviceUrl = 'http://rdserviceonline.com';
            break;
            
          case 5:
          deviceUrl = 'https://secugen.com/drivers/';
          break;
        
          default:
            break;
        }
        window.open(deviceUrl, 'blank');
      }

    };

  }
  deviceCapture(device) {
        console.log(device);
        let deviceValue = device;
        let captureUrl = 'http://127.0.0.1:11100/';
        if (deviceValue==3 || deviceValue==8 || deviceValue==4||deviceValue==5) {
            captureUrl+='rd/capture';
        }else if(deviceValue==1){
          captureUrl='https://127.0.0.1:11100/capture';
        }else if (deviceValue==6) {
          captureUrl="https://127.0.0.1:8005/rd/capture";
        }
        const xhr = new XMLHttpRequest();
        xhr.open('CAPTURE',captureUrl);
        if(this.service=='FINO_BANK'||this.service=='FINO_AADHAR'){

          var reqParam = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" iType="0" format="0" pidVer="2.0" otp="" wadh="" timeout="10000" posh="UNKNOWN" env="P" /><Demo></Demo> <CustOpts></CustOpts> </PidOptions>';
         
        }

        else{
          var reqParam = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" format="0"   pidVer="2.0" timeout="10000" posh="UNKNOWN" wadh="" env="P" /></PidOptions>';

          // var reqParam = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts env="PP" fCount="1" fType="2" iCount="0" format="0" pidVer="2.0" timeout="15000" wadh="" posh="UNKNOWN" /> </PidOptions>';
          // var reqParam = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0"   pidVer="2.0" timeout="10000" posh="UNKNOWN" env="PP" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';
        }
        xhr.setRequestHeader('Content-Type', 'text/xml');
      
          console.log('reqParam', reqParam);
    
          // pass `params` to `send()` method
          xhr.send(reqParam);
      
        // }

    
        // listen for `load` event
        xhr.onload = async () => {
          const parser = new DOMParser();
          const xml = parser.parseFromString(xhr.responseText, 'text/xml');
          console.log(xml,'xml value check >>>>>>>')
          // this.Aeps.setcaptureDeviceInfoObjInXML(xml);
          var dataRes=this.XMLToString(xml);
          var dataRes=dataRes.toString().replace("\\n", "");
          // this.deviceStringData=btoa(dataRes);
          this.deviceStringData=dataRes;
          console.log(this.deviceStringData,'check device string value >>>')
          // this.deviceStringData = dataRes.toString();
          this.captureDeviceInfoObj = await this.xmlToJsonfn(xml);
          console.log('this.captureDeviceInfoObj:::', this.captureDeviceInfoObj);
          var deviceInfo =this.captureDeviceInfoObj;
          if (this.captureDeviceInfoObj.PidData) {
              if(deviceInfo && deviceInfo.PidData && deviceInfo.PidData.Resp['@attributes'].errCode == '0'){
                this.auth.getIp().subscribe((res:any)=>{
                  this.ipAddress=res.ip;
                 })
                 var latitude=parseFloat(this.lat).toFixed(4);
                 var longitute=parseFloat(this.lng).toFixed(4);
                 var deviceSerialNumber = '';
                 if (this.kycForm.value.device==1 ||  this.kycForm.value.device==8 || this.kycForm.value.device==4) {
                   deviceSerialNumber = deviceInfo.PidData.DeviceInfo.additional_info.Param["@attributes"].value;              
                 }else{
                   deviceSerialNumber = deviceInfo.PidData.DeviceInfo.additional_info.Param[0]["@attributes"].value;
                 }
               
                this.spinner.show();
                if(this.service=='FINO_BANK' ||this.service=='FINO_AADHAR'){
                  const deviceParams = {
                    ci: deviceInfo.PidData.Skey['@attributes'].ci,
                    dc: deviceInfo.PidData.DeviceInfo['@attributes'].dc,
                    dpID: deviceInfo.PidData.DeviceInfo['@attributes'].dpId,
                    errCode: deviceInfo.PidData.Resp['@attributes'].errCode,
                    errInfo: deviceInfo.PidData.Resp['@attributes'].errInfo,
                    fCount: deviceInfo.PidData.Resp['@attributes'].fCount,
                    fType: deviceInfo.PidData.Resp['@attributes'].fType,
                    hmac: deviceInfo.PidData.Hmac['#text'],
                    iCount: '0',
                    mc: deviceInfo.PidData.DeviceInfo['@attributes'].mc,
                    mi: deviceInfo.PidData.DeviceInfo['@attributes'].mi,
                    nmPoints: deviceInfo.PidData.Resp['@attributes'].nmPoints,
                    pCount: '0',
                    pType: '0',
                    pidDatatype: deviceInfo.PidData.Data['@attributes'].type,
                    piddata: deviceInfo.PidData.Data['#text'],
                    qScore: deviceInfo.PidData.Resp['@attributes'].qScore,
                    rdsID: deviceInfo.PidData.DeviceInfo['@attributes'].rdsId,
                    rdsVer: deviceInfo.PidData.DeviceInfo['@attributes'].rdsVer,
                    sessionKey: deviceInfo.PidData.Skey['#text'],
                    
                  };  
                  var cardnumberORUIDObj = {
                    adhaarNumber: this.kycForm.value.aadharNum,
                    indicatorforUID: 0,
                    nationalBankIdentificationNumber: 0

                  };
                  this.finoRequest = {
                    captureResponse: deviceParams,
                    cardnumberORUID: cardnumberORUIDObj,
                    latitude: latitude,
                    longitude: longitute,
                    mobileNumber: this.kycForm.value.mobileNum,
                    requestRemarks: "2FA"
                 
                  };
                }
                if(this.service=='FINO_AADHAR' && this.selectedServiceType=='aadhaar_pay'){
                  this.kycservice.aadharpay2fa(this.finoRequest,deviceSerialNumber,'DAILY').subscribe((res: any) => {
                    console.log('kyc response::', res);
                    this.spinner.show();
                    if (res.status_code == 1) {
                      this.spinner.hide();
                     
                      const dialogRef = this.dialog.open(KYCSuccessDialogComponentComponent, {
                        width: '250px',
                        height: '250px',
                        disableClose: true,
                        data: '2fa'
                      });
                      this.submitted = false;
                      this.kycForm.reset();
                    } else {
                      this.toastr.error(res.error.message);
                      this.spinner.hide();
                    }
                  });        
               
                }else if(this.service=='FINO_BANK'){
                  this.kycservice.fino2fa(this.finoRequest,deviceSerialNumber,'DAILY').subscribe((res: any) => {
                    console.log('kyc response::', res);
                    this.spinner.show();
                    if (res.status_code == 1) {
                      this.spinner.hide();
                      this.submitted = false;
                      this.kycForm.reset();
                      const dialogRef = this.dialog.open(KYCSuccessDialogComponentComponent, {
                        width: '250px',
                        height: '250px',
                        disableClose: true,
                        data: '2fa'
                      });
                    } else {
                      this.toastr.error(res.error.message);
                      this.spinner.hide();
                    }
                  });        
               
                }
                else if(this.service=='YES_BANK'){
                  var yesBankRequest={
                    "aadharNumber": this.kycForm.value.aadharNum,
                    "amount": 0,
                    "bankIIN": "607618",
                    "biometricData":this.deviceStringData, 
                    "customerMobileNumber": this.kycForm.value.mobileNum,
                    "device": "LAPTOP",
                    "ipAddress": this.ipAddress,
                    "latitute": latitude,
                    "longitute": longitute,
                    "rdsVersion": deviceInfo.PidData.DeviceInfo['@attributes'].rdsVer,
                    "serviceType": "AEPS_CASH_WITHDRAWL"
                  }
                
                console.log('finoRequest inside component:::', yesBankRequest);
                  this.kycservice.yb2fa(yesBankRequest,deviceSerialNumber,'DAILY').subscribe((res: any) => {
                    console.log('kyc response::', res);
                    this.spinner.show();
                    if (res.status_code == 1) {
                      this.spinner.hide();
                      this.submitted = false;
                      this.kycForm.reset();
                      const dialogRef = this.dialog.open(KYCSuccessDialogComponentComponent, {
                        width: '250px',
                        height: '250px',
                        disableClose: true,
                        data: '2fa'
                      });
                    } else {
                      this.toastr.error(res.error.message);
                      this.spinner.hide();
                    }
                  });        
               
                }
              }else{
                this.spinner.hide();
                this.toastr.error(deviceInfo.PidData.Resp['@attributes'].errInfo);
             
              }
          }
          // return xhr.responseText;
        };
      } 
      xmlToJsonfn(xml) {
      
        // Create the return object
        var obj = {};
    
        if (xml.nodeType == 1) { // element
          // do attributes
          if (xml.attributes.length > 0) {
            obj["@attributes"] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
              var attribute = xml.attributes.item(j);
              obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
            }
          }
        } else if (xml.nodeType == 3) { // text
          obj = xml.nodeValue;
        }
    
        // do children
        if (xml.hasChildNodes()) {
          for (var i = 0; i < xml.childNodes.length; i++) {
            var item = xml.childNodes.item(i);
            var nodeName = item.nodeName;
            if (typeof (obj[nodeName]) == "undefined") {
              obj[nodeName] = this.xmlToJsonfn(item);
            } else {
              if (typeof (obj[nodeName].push) == "undefined") {
                var old = obj[nodeName];
                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(this.xmlToJsonfn(item));
            }
          }
        }
        return obj;
      };
doKYC() {
  this.submitted = true;
  // stop here if form is invalid
  if (this.kycForm.invalid) {
    return;
  }
  else {
    this.Aeps.deviceInfoAvdm(this.kycForm);

  }
}
numberOnly(event): boolean {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}


ngOnDestroy() {
  // You can also do whatever you need here
}

}
